/**
 * created by lei lei
 * 任务全部
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, DatePicker, Input, Modal, Select, Tabs, Row, Col, Radio, Pagination, message, Empty} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import SpacerBlock from "../../../components/spacerBlock/SpacerBlock";
import *as actions from"../../../../actions/manuscriptPool"
import *as utils from'../../../../utils/index'
import {applicationName} from "../../../../utils";
const {MonthPicker, RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const {TabPane} = Tabs;
const {Search} = Input;

export default class TaskAll extends Component {
    static defaultProps = {newSecondSelectColor: '#0050B3'};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.actions=actions;
        this.state = {
            taskTitle: '',
            selectVisible: false,
            selectKey: '新闻报道',
            page: 1,//当前页
            size: 10,//每页条数,
            showTab: false,
            img: '',
            topBtn: true,
            listData:[],
            count:0,
            currentChoose:{}
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    showTask(params) {
        this.state. page=1;
        this.state. size=10;
        this.state. selectVisible=true;
        this.state. currentChoose={};
        this.state. listData=[];
        this.state. count=0;
        this.typeGet();
        setTimeout(() => {
            this.scrollRef && this.scrollRef.scrollToTop();
        });
    }

    //根据类型获取数据
    typeGet(){

            this.getTask()
    }

    //获取关联任务
    getTask(){
        let body={
            start:this.state.page,
            size:this.state.size,
        };

        let listData=[];
        let count=0;
        myInterviews(body,data=>{
            if(data&&data.data){
                listData =data.data;
                count=data.count;
            }
            this.setState({
                listData:listData,
                count:count,
            })
        })
    }


    render() {
        let newSecondSelectColor = this.props.newSecondSelectColor;
        return (
            <div>

                <Modal className={'selectManuscriptPool'}
                       title={'任务列表'}
                       visible={this.state.selectVisible}
                       onOk={() => {
                           //this.onOk();
                       }}
                       okText={'确认选择'}
                       cancelText={null}
                       width={900}
                       onCancel={() => {
                           this.setState({selectVisible: false})
                       }}
                       zIndex={500}
                       footer={null}
                >
                    <div style={{height: '65vh'}}>
                        <div style={{height: "calc(65vh - 65px)"}}>
                            <Scrollbars ref={(scrollRef) => {
                                this.scrollRef = scrollRef
                            }}>
                                {this.state.listData.length=== 0 ? <div style={{ height: '100%', display:'flex', justifyContent: 'center',alignItems: 'center'}}><Empty/></div> : null}
                                {
                                    this.state.listData.map((item,i)=>{

                                        return(
                                            <div key={i}>
                                                <div style={{}}>
                                                    <Row>
                                                        <Col span={3}>
                                                            <div style={{textAlign: 'center',height:79,lineHeight:'79px'}}>
                                                                <img
                                                                    style={{height: 40, width: 40, borderRadius: 5}}
                                                                    src={'images/newsactivity/newactivity_flag.png'} alt=""/></div>
                                                        </Col>
                                                        <Col span={18}>
                                                            <div onClick={()=>{this.itemClick(item)}} style={{marginTop: 17}}>
                                                                <div style={{
                                                                    position: 'relative', overflow: 'hidden',
                                                                    textOverflow: 'ellipsis', fontWeight: 'bold',
                                                                    whiteSpace: 'nowrap',color:'#2a3a6b',fontSize:16
                                                                }}>{item.tsName||item.title}</div>
                                                                <div style={{
                                                                    position: 'relative', overflow: 'hidden',
                                                                    textOverflow: 'ellipsis', color: '#a4adc8',fontSize:14,
                                                                    whiteSpace: 'nowrap'
                                                                }}>
                                                                    {item.tsContent||item.content}
                                                                </div>

                                                            </div>
                                                        </Col>
                                                        <Col span={3}>
                                                            <div style={{height:79,lineHeight:'79px',display:'flex'}}>
                                                                {this.formateStatus(item.status,item)}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <SpacerBlock height={1}/>
                                            </div>
                                        )
                                    })
                                }



                            </Scrollbars>
                            <div style={{padding: 10, float: 'right'}}>
                                <Pagination
                                    showQuickJumper
                                    // defaultCurrent={2}
                                    current={this.state.page}
                                    pageSize={this.state.size}
                                    total={this.state.count}
                                    showTotal={total => `共 ${total} 条`}
                                    showSizeChanger
                                    onChange={(page, pageSize) => this.onChange(page, pageSize)}
                                    onShowSizeChange={(page, pageSize) => {
                                        this.onChange(page, pageSize)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
    onOk(){
        //if(this.state.taskTitle==='关联选题'){
        if(!this.state.currentChoose.id){
            message.info('请选择'+this.state.taskTitle);
            return;
        }
        //}
        let parms = {taskTitle: this.state.taskTitle, topBtn: this.state.topBtn,...this.state.currentChoose};
        this.props.callBack && this.props.callBack(parms);

    }

    itemClick(item){
        this.props.callBack && this.props.callBack(item);
    }

    onChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.typeGet();
    }

    formateStatus(value,row){

        let activityTime;//活动时间
        if(row.endDate){
            activityTime=row.endDate.time;
        }else{
            activityTime=row.interviewEndDate?row.interviewEndDate.time:0;//活动时间
        }
        let nowDate=new Date().getTime();//当前时间
        if(value==1){
            let statusName = "未领取";
            if(activityTime){
                statusName=activityTime<nowDate?'已超期':'未领取';
            }
            if(statusName==='未领取'){
                return <div className={"unget_status"} style={{margin:'auto'}}>{statusName}</div>
            }else{
                return <div className={"overdue"} style={{margin:'auto'}}>{statusName}</div>
            }
        }else if(value==2){
            return <div className={"recieve_status"} style={{margin:'auto'}}>进行中</div>
        }else if(value==3){
            return <div className={"submitted_status"} style={{margin:'auto'}}>已提交</div>
        }else if(value==4){
            return <div className={"publish_status"} style={{margin:'auto'}}>已完成</div>
        }
    }


}
let cacheAndcredentials = {cache: 'no-cache', /*credentials: 'include'*/};
//获取任务列表
export function myInterviews(body, callBack) {
    let url = encodeURI("/cm-sites-" + applicationName() + '/'+'interview/all' + utils.params(body)+'&time='+new Date().getTime());
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:myInterviews", error);
        callBack({});
    })
}

